module.exports = __webpack_public_path__ + "static/img/Barry_h5.3c323a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Barry_h5.png
// module id = Fyud
// module chunks = 34